(function () {
  'use strict';

  /* @ngdoc object
   * @name myMemberships.memberships
   * @description
   *
   */
  angular
    .module('myMemberships.memberships', [
      'ui.router'
    ]);
}());
